import type { OverlayStyle } from "../overlay/types";

// Primary drawing preview (rectangle, circle, ellipse, line)
export const PREVIEW_SHAPE_STYLE: Partial<OverlayStyle> = {
  strokeColor: "#0088ff",
  strokeWidth: 2,
  fillColor: "rgba(0, 136, 255, 0.1)",
};

// Line/Freehand preview (no fill)
export const PREVIEW_LINE_STYLE: Partial<OverlayStyle> = {
  strokeColor: "#0088ff",
  strokeWidth: 2,
};

// Dashed rubber band (polyline feedback)
export const PREVIEW_RUBBER_BAND_STYLE: Partial<OverlayStyle> = {
  strokeColor: "#0088ff",
  strokeWidth: 2,
  lineDash: [5, 5],
};

// Completion indicator (closeable polyline, zoom window)
export const PREVIEW_COMPLETION_STYLE: Partial<OverlayStyle> = {
  strokeColor: "#00cc00",
  strokeWidth: 2,
  fillColor: "rgba(0, 204, 0, 0.2)",
};

// "Will close" indicator - shows when releasing will auto-close the shape
// More prominent than PREVIEW_COMPLETION_STYLE to indicate imminent action
export const PREVIEW_WILL_CLOSE_STYLE: Partial<OverlayStyle> = {
  strokeColor: "#00ff00",
  strokeWidth: 3,
  fillColor: "rgba(0, 255, 0, 0.4)",
};

// Text preview
export const PREVIEW_TEXT_STYLE: Partial<OverlayStyle> = {
  fillColor: "#0088ff",
};

// Block placement preview (higher opacity fill)
export const PREVIEW_BLOCK_STYLE: Partial<OverlayStyle> = {
  strokeColor: "#0088ff",
  strokeWidth: 2,
  fillColor: "rgba(0, 136, 255, 0.3)",
};

// Origin marker
export const PREVIEW_ORIGIN_STYLE: Partial<OverlayStyle> = {
  strokeColor: "#ff4444",
  strokeWidth: 2,
};

// Measurement label (dimension text during drawing)
export const MEASUREMENT_LABEL_STYLE: Partial<OverlayStyle> = {
  fillColor: "#333333",
  strokeWidth: 0,
  opacity: 1,
};

// Measurement guide line/arc (dimension indicator during resize/rotate)
export const MEASUREMENT_GUIDE_STYLE: Partial<OverlayStyle> = {
  strokeColor: "#888888",
  strokeWidth: 1,
  lineDash: [4, 3],
  opacity: 0.6,
};

// Snap constraint guide line (ortho/polar visual feedback)
export const SNAP_GUIDE_STYLE: Partial<OverlayStyle> = {
  strokeColor: "#00cc00",
  strokeWidth: 1,
  lineDash: [6, 4],
  opacity: 0.7,
};
